<script setup lang="ts">
import GenericError from '~/components/user-interface/generic-error.vue';

const { $authService } = useServices();
const { $trackEvent } = useNuxtApp();

const authStore = useAuthStore();
const loading = ref<boolean>(true);

const fetchArray = [
  $authService.getRewardsConfig(),
  $authService.getRewardsSummary(),
];

const fetchRewards = () => {
  try {
    Promise.allSettled(fetchArray).finally(() => (loading.value = false));
  } catch (e) {
    console.error(e);
  }
};

onMounted(() => {
  fetchRewards();
  $trackEvent('Account', 'MY_ACCOUNT_SETTINGS', {
    to: 'rewards',
  });
});
</script>

<template>
  <div class="jpc-rewards md:p-4">
    <div
      class="text-base-priority rounded-lg pt-3 w-full md:max-w-[328px] mx-auto mb-4 bg-layer"
    >
      <LazyUserInterfaceGenericLoader v-if="loading" />
      <div v-else class="grid grid-cols-1 gap-4">
        <p class="font-bold text-base px-4 m-0 py-0">{{ $t('jpc-rewards') }}</p>
        <hr class="bg-layer-2-border-color mt-0" />
        <LazyUserRewardsBalance v-if="!!authStore.getRewardsConfig" />
        <div
          v-if="
            !!authStore.getRewardsConfig ||
            !!authStore.getSummaryYearConfig.length
          "
          class="p-2 gap-4 flex-col flex relative"
        >
          <LazyUserRewardsRedeem @points-redeemed="fetchRewards" />
          <LazyUserRewardsSummary />
          <LazyUserRewardsAccordion />
        </div>
      </div>
      <GenericError
        v-if="
          !loading &&
          !authStore.getSummaryYearConfig.length &&
          !authStore.getRewardsConfig
        "
        class="px-2 pt-2 pb-4"
      >
        {{ $t('rewards-error') }}
      </GenericError>
    </div>
  </div>
</template>
